// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const CircleIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 66 66">
          <path fill="inherit" d="M0 26.492C.002 11.86 11.86.002 26.492 0c14.633.002 26.49 11.86 26.494 26.492-.004 14.633-11.86 26.49-26.494 26.494C11.862 52.982.002 41.126 0 26.492zm6 0c.02 11.316 9.176 20.474 20.493 20.492 11.316-.02 20.474-9.176 20.492-20.492C46.965 15.175 37.81 6.02 26.492 6 15.175 6.02 6.02 15.175 6 26.492z"/>
        </svg>
      )
    }
  </Icon>
);

export default CircleIcon;
